export default "__VITE_ASSET__BWiCa5u7__"